import { useState } from "react";
import { Row, Col, Form, Container, FormGroup, Breadcrumb, Navbar, } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";
import Swal from "sweetalert";
import moment from "moment";
import { getDateWiseSaleReport } from "./Report.action";
import { Link } from "react-router-dom";
import IconMenu from "../../../drawer/IconMenu";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const DateWiseSaleReport = (props) => {
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


  const handleDangerVisible = () => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: "Something went Wrong!",
      icon: "error",
      button: "Ok",
    });
  };
  const exportPDF = () => {
    props.getDateWiseSaleReport({ current_date: startDate },
      handleDangerVisible
    );
  };

  return (
    <>
      <Navbar style={{ backgroundColor: '#81abd3' }}  >
        <Container>
          <Navbar.Brand style={{ color: 'white' }}><b>Daily Sale Report</b></Navbar.Brand>
          <IconMenu />
        </Container>
      </Navbar>

      <Container fluid>
        <div className="main">
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item ><Link to="/home">Home</Link></Breadcrumb.Item>
              <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
              <Breadcrumb.Item active>Daily Sale Report</Breadcrumb.Item>
            </Breadcrumb>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Form.Label><b>Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                ></Form.Control>
              </FormGroup>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(startDate) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> Generate Report </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => exportPDF()}> Generate Report </Button>
            )}
          </div>

        </div>
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDateWiseSaleReport: (data, handleDangerVisible) => dispatch(getDateWiseSaleReport(data, handleDangerVisible)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingSaleReport: state.ReportReducer.isFetchingSaleReport,
  saleReportData: state.ReportReducer.saleReportData,
});

export default connect(mapStateToProps, mapDispatchToProps)(DateWiseSaleReport);